import StoryblokLink from "./StoryblockLink";

export default StoryblokLink;
